import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  selector: 'app-modal-menu',
  templateUrl: './modal-menu.component.html',
  styleUrls: ['./modal-menu.component.scss']
})
export class ModalMenuComponent implements OnInit {
  @Input() modalContentHTML: string = ''
  @Input() size: string = 'modal-xl';
  @Input() idModal: string = 'modalCore';
  safeHTML: any;

  constructor(private Sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    //Evitar remover etiquetas HTML como <input> y permite eventos JS
    this.safeHTML = this.Sanitizer.bypassSecurityTrustHtml(this.modalContentHTML);
  }
}
